import gql from "graphql-tag";

const ProjectWasteTypeCustomFragment = gql`
  fragment projectWasteTypeCustom on projectWasteTypeCustom {
    id
    label
  }
`;

export default ProjectWasteTypeCustomFragment;
